
import Vue from 'vue'

export default Vue.extend({
    name: 'Contact',
    components: {
    },
    computed: {
        typeFormUrl() {
            return process.env.VUE_APP_TYPEFORM_URL;
        }
    },
    data(){
        return{
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            valid: false,
            avatarList:[
                {
                    src: 'lead-generation.png',
                    title: 'Lead generation agent',
                },
                {
                    src: 'sdr.png',
                    title: 'SDR agent',
                },
                {
                    src: 'telesales.png',
                    title: 'Telesales agent',
                },
                {
                    src: 'customer-support.png',
                    title: 'Customer support agent',
                },
                {
                    src: 'call-center.png',
                    title: 'Call center agent',
                },
                {
                    src: 'help-desk-analyst.png',
                    title: 'Help desk analyst',
                },
                {
                    src: 'email-marketing.png',
                    title: 'Email marketing agent',
                },
                {
                    src: 'seo.png',
                    title: 'SEO agent',
                },
                {
                    src: 'market-research.png',
                    title: 'Market research agent',
                }
            ]
        }
    },
    methods: {
    },
    mounted() {
    }
})
